const DateFormats = Object.freeze({
  DEFAULT: 'YYYY-MM-DD',
  MM_DD_YYYY: 'MM/DD/YYYY',
  M_DD: 'M/DD',
  UTC: 'YYYY-MM-DDTHH:mm:ss[Z]',
});

export {DateFormats};
